import React, { useState } from 'react'
import { CreateJobForm } from '../hooks/variables/CreateJobForm'
import { ReactInput } from '../ui/ReactInput'
import { workMode, jobType, noticePeriod, priorityOptions, Status, industryTypes } from '../data/dropdownOptions'
import { formats, modules } from '../utils/wordOption'
import { AiFillQuestionCircle } from "react-icons/ai";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

export const CreateJob = () => {
  const { createJob, setCreateJob, handleChange, errors, currentUser, teamLeadOption, mangerOption, assignedToOption, handleSubmit, filteredSpocOption, clientOption, isUpdate, primaryRecruiterOptions, loading, handleDesChange ,handleFieldChange} = CreateJobForm()

  // const renderField = (field) => (
  //   <ReactInput
  //     type={field.type}
  //     key={field.name}
  //     label={field.label}
  //     placeholder={field.placeholder}
  //     name={field.name}
  //     // value must be array for tagInput / isMulti
  //     value={field.value || (field.isMulti || field.tagInput ? [] : "")}
  //     mandatory={field?.mandatory}
  //     error={field?.error}
  //     className="w-full"

  //     options={field?.option}
  //     readOnly={field?.readOnly}

  //     reactSelect={field?.reactSelect}
  //     isMulti={field?.isMulti}
  //     reactSelectOptions={field?.reactSelectOptions}
  //     creatable={field?.creatable}

  //     // NEW: pass tagInput prop to ReactInput
  //     tagInput={field?.tagInput || false}

  //     onChange={(val) => {
  //       // If this field uses react-select OR tagInput (both return value directly),
  //       // store it into nested createJob path (supports dot-path like "location.city")
  //       if (field?.reactSelect || field?.tagInput) {
  //         if (["reportingManager.id", "reportingTeamLead.id", "assignedTo"].includes(field.name)) {
  //           setCreateJob({
  //             ...createJob,
  //             primaryRecruiter: {
  //               id: ""
  //             }
  //           })
  //         }

  //         const keys = field.name.split(".");
  //         setCreateJob((prev) => {
  //           const copy = { ...prev };
  //           let temp = copy;
  //           keys.forEach((k, i) => {
  //             if (i === keys.length - 1) {
  //               // set final key to val (array for tagInput / whatever react-select returns)
  //               temp[k] = val;
  //             } else {
  //               temp[k] = { ...temp[k] };
  //               temp = temp[k];
  //             }
  //           });
  //           return copy;
  //         });
  //       } else {
  //         // default handler for simple inputs (keep your existing logic)
  //         handleChange(val);
  //       }
  //     }}
  //   />
  // );


  // Render field dynamically
  const renderField = (field) => {
    // determine displayed value (same as earlier)
    const value = field.reactSelect || field.tagInput
      ? (field.value ?? (field.isMulti || field.tagInput ? [] : ""))
      : (typeof field.value === "object" && field.value !== null
        ? (field.value.value ?? field.value.label ?? "")
        : (field.value ?? ""));

    // For react-select/tagInput we call handleChange(name, value)
    // For native inputs we pass the event: handleChange(e)
    const onChangeHandler = field.reactSelect || field.tagInput
      ? (val) => handleChange(field.name, val)
      : (e) => handleChange(e);

    return (
      <ReactInput
        key={field.name}
        type={field.type}
        label={field.label}
        name={field.name}
        placeholder={field.placeholder}
        mandatory={field.mandatory}
        error={field.error}
        readOnly={field.readOnly}
        className="w-full"
        reactSelect={field.reactSelect}
        isMulti={field.isMulti}
        tagInput={field.tagInput}
        reactSelectOptions={field.reactSelectOptions}
        creatable={field.creatable}
        options={field.option}
        value={value}
        onChange={onChangeHandler}
      />
    );
  };







  return (
    <div className='flex justify-center px-5 md:px-28 py-5 md:py-10 '>
      <form className="w-full  bg-blue-50 p-5 rounded-xl gap-4">
        <h2 className='font-bold uppercase'>Job details :</h2>
        <div className='grid grid-cols-1 md:grid-cols-3 w-full gap-4 mt-2'>
          <div className="col-span-1 md:col-span-3 rounded-xl bg-white p-3">
            <div className='grid grid-cols-1 md:grid-cols-3 gap-4 items-start'>
              {renderField
                ({
                  label: "Job code",
                  placeholder: "e.g : JB-1234 / 001 / @DEV",
                  value: createJob?.internalJobId,
                  name: "internalJobId",
                  mandatory: true,
                  error: errors?.internalJobId,
                  type: "text"
                })}
              {renderField
                ({
                  label: "Job Title",
                  placeholder: "e.g : Software Engineer",
                  value: createJob?.title,
                  name: "title",
                  mandatory: true,
                  error: errors?.title,
                  type: "text"
                })}
              {renderField
                ({
                  label: "Client Job Id",
                  placeholder: "e.g : JB-1234 / 001 / @DEV",
                  value: createJob?.clientJobId,
                  name: "clientJobId",
                  type: "text"
                })}
            </div>
          </div>

          <div className="col-span-1 md:col-span-3 rounded-lg ">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div className='bg-white p-3 rounded-xl'>
                <div className="font-medium text-lg  mb-2 flex items-center gap-3">Client Pay Range (LPA) <AiFillQuestionCircle size={20} /></div>
                <div className='grid grid-cols-2 gap-2 items-start'>
                  {renderField
                    ({
                      label: "Currency",
                      placeholder: "Currency",
                      value: "INR",
                      name: "maxClientBudget.currency",
                      // option: currencyOptions ,
                      type: "text",
                      readOnly: true
                    })}
                  {renderField
                    ({
                      label: "Amount",
                      placeholder: "e.g : 5 or 5.5 ",
                      value: createJob?.maxClientBudget?.amount,
                      name: "maxClientBudget.amount",
                      type: 'tel',
                      error: errors?.["maxClientBudget.amount"]
                    })}
                </div>
              </div>
              <div className='bg-white p-3 rounded-xl'>
                <div className="font-medium text-lg  mb-2 flex items-center gap-3">Pay Range (LPA) <AiFillQuestionCircle size={20} /></div>
                <div className='grid grid-cols-1 lg:grid-cols-3 gap-2 items-start'>
                  {renderField
                    ({
                      label: "Currency",
                      placeholder: "Currency",
                      value: 'INR',
                      name: "payRange.currency",
                      type: "text",
                      readOnly: true
                    })}
                  {renderField
                    ({
                      label: "Min",
                      placeholder: "e.g : 5 or 5.5 ",
                      value: createJob?.payRange?.min,
                      name: "payRange.min",
                      mandatory: true,
                      type: 'tel',
                      error: errors?.["payRange.min"]
                    })}
                  {renderField
                    ({
                      label: "Max",
                      placeholder: "e.g : 5 or 5.5 ",
                      value: createJob?.payRange?.max,
                      name: "payRange.max",
                      mandatory: true,
                      error: errors?.["payRange.max"],
                      type: 'tel',                
                    })}
                </div>
              </div>
            </div>
          </div>


          <div className="col-span-1 md:col-span-3 rounded-lg ">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div className='bg-white p-3 rounded-xl'>
                <div className="font-medium text-lg  mb-2 flex items-center gap-3">Job Date</div>
                <div className='grid grid-cols-2 gap-2 items-start'>
                  {renderField
                    ({
                      label: "Start date",
                      value: createJob?.startDate,
                      name: "startDate",
                      type: "date",
                      error: errors.startDate
                    })}
                  {renderField
                    ({
                      label: "End date",
                      value: createJob?.endDate,
                      name: "endDate",
                      type: "date",
                      error: errors.endDate,
                      readOnly: !createJob?.startDate,
                    })}
                </div>
              </div>
              <div className='bg-white p-3 rounded-xl '>
                <div className="font-medium text-lg   mb-2 flex items-center gap-3 capitalize">Type</div>
                <div className='grid grid-cols-1 lg:grid-cols-3 gap-2 items-start'>
                  {renderField
                    ({
                      label: "Job Type",
                      placeholder: "Select",
                      mandatory: true,
                      value: jobType.find(option => option.value === createJob?.jobType) || createJob?.jobType,
                      name: "jobType",
                      reactSelect: true,
                      reactSelectOptions: jobType,
                      error: errors.jobType
                    })}
                  {renderField
                    ({
                      label: "Mode",
                      placeholder: "Select",
                      mandatory: true,
                      value: workMode.find(option => option.value === createJob?.mode) || createJob?.mode,
                      name: "mode",
                      reactSelect: true,
                      reactSelectOptions: workMode,
                      error: errors.mode
                    })}
                  {renderField
                    ({
                      label: "Industry",
                      placeholder: "Select",
                      mandatory: true,
                      value: industryTypes.find(option => option.value === createJob?.industry) || createJob?.industry,
                      name: "industry",
                      reactSelect: true,
                      reactSelectOptions: industryTypes,
                      error: errors.industry
                    })}
                </div>
              </div>
            </div>
          </div>

          <div className="col-span-1 md:col-span-3 rounded-xl bg-white p-3">
            <div className='grid grid-cols-1 md:grid-cols-3 gap-4 items-start'>
              {renderField
                ({
                  label: "Qualification",
                  placeholder: "Enter qualification",
                  value: createJob?.minQualification,
                  name: "minQualification"
                })}
              {renderField
                ({
                  label: "Notice period",
                  placeholder: "Select",
                  mandatory: true,
                  value: createJob?.noticePeriod,
                  name: "noticePeriod",
                  reactSelect: true,
                  reactSelectOptions: noticePeriod,
                  error: errors.noticePeriod
                })}
              <div className='grid grid-cols-1 lg:grid-cols-2 gap-3'>
                {renderField
                  ({
                    label: "Priority",
                    placeholder: "Select",
                    value: createJob?.priority,
                    name: "priority",
                    reactSelect: true,
                    reactSelectOptions: priorityOptions,
                    error: errors.priority
                  })}
                {renderField
                  ({
                    label: "Vacancies",
                    placeholder: "vacancies",
                    value: createJob?.vacancies,
                    name: "vacancies",
                    error: errors?.vacancies
                  })}
              </div>

            </div>
          </div>

          <div className='col-span-1 md:col-span-3 bg-white p-3 rounded-xl'>
            <div className="font-medium text-lg  mb-2 flex items-center gap-3">Select Assign</div>
            <div className='grid grid-cols-1 lg:grid-cols-4 gap-2 items-start'>
              {renderField({
                label: "Manager",
                placeholder: "Select manager",
                mandatory: true,
                value: createJob?.reportingManager?.id || null,
                name: "reportingManager.id",
                reactSelect: true,
                readOnly:
                  currentUser.role === "admin"
                    ? false
                    : ["manager", "teamlead", "recruiter"].includes(currentUser.role),
                reactSelectOptions: mangerOption,
                error: errors["reportingManager.id"]
              })}
              {renderField
                ({
                  label: "Teamlead",
                  placeholder: "Select teamlead",
                  value: createJob?.reportingTeamLead?.id,
                  name: "reportingTeamLead.id",
                  readOnly: currentUser.role === "teamlead" ? true : currentUser.role === "recruiter" ? true : false,
                  reactSelect: true,
                  reactSelectOptions: currentUser.role === "teamlead" ? teamLeadOption : teamLeadOption,
                })}
              {renderField
                ({
                  label: "Assigned to",
                  placeholder: "Select assigned to",
                  mandatory: true,
                  value: createJob?.assignedTo || [],
                  name: "assignedTo",
                  readOnly: currentUser.role === "recruiter" ? true : false,
                  reactSelect: true,
                  isMulti: true,
                  reactSelectOptions: assignedToOption,
                  error: errors["assignedTo"]
                })}
              {renderField
                ({
                  label: "SAN SPOC",
                  placeholder: "Select SAN SPOC",
                  mandatory: true,
                  value: createJob?.primaryRecruiter?.id,
                  name: "primaryRecruiter.id",
                  readOnly: isUpdate ? (["admin", "manager", "teamlead"].includes(currentUser.role) ? false : true) : false,
                  reactSelect: true,
                  reactSelectOptions: primaryRecruiterOptions || [],
                  error: errors["primaryRecruiter.id"]
                })}
            </div>
          </div>

          <div className="col-span-1 md:col-span-3 rounded-lg ">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div className='bg-white p-3 rounded-xl'>
                <div className="font-medium text-lg  mb-2 flex items-center gap-3">Client / Spoc</div>
                <div className='grid grid-cols-1 lg:grid-cols-2 gap-2 items-start'>
                  {renderField({
                    label: "Client",
                    placeholder: "Select client",
                    mandatory: true,
                    value: createJob?.client.id,
                    name: "client.id",
                    reactSelect: true,
                    reactSelectOptions: clientOption,
                    error: errors["client.id"]
                  })}
                  {renderField({
                    label: "Spoc",
                    placeholder: "Select spoc",
                    mandatory: true,
                    value: createJob?.spoc?.id,
                    name: "spoc.id",
                    // option : filteredSpocOption,
                    reactSelect: true,
                    reactSelectOptions: filteredSpocOption,
                    error: errors["spoc.id"]
                  })}
                </div>
              </div>
              <div className='bg-white p-3 rounded-xl'>
                <div className="font-medium text-lg  mb-2 flex items-center gap-3">Experience</div>
                <div className='grid grid-cols-1 lg:grid-cols-2 gap-2 items-start'>
                  {renderField
                    ({
                      label: "Min",
                      placeholder: "e.g : 5 or 5.5",
                      mandatory: true,
                      value: createJob?.experience?.min,
                      name: "experience.min",
                      error: errors?.["experience.min"]
                    })}
                  {renderField
                    ({
                      label: "Max",
                      placeholder: "e.g : 5 or 5.5",
                      mandatory: true,
                      value: createJob?.experience?.max,
                      name: "experience.max",
                      error: errors?.["experience.max"]
                    })}
                </div>
              </div>
            </div>
          </div>

          <div className="col-span-1 md:col-span-3 rounded-xl bg-white p-3">
            <div className='grid grid-cols-1 lg:grid-cols-3 gap-4 items-start'>
              {renderField({
                label: "City",
                mandatory: true,
                placeholder: "e.g.: Type city name, then press Enter to add",
                value: createJob?.city || [],
                name: "city",
                tagInput: true,
                error: errors["city"] || ""
              })}

              {renderField({
                label: "Skills",
                mandatory: true,
                placeholder: "e.g.: Type skill name, then press Enter to add",
                value: createJob?.skills || [],
                name: "skills",
                tagInput: true,
                error: errors.skills || ""
              })}

              {isUpdate && (
                renderField({
                  label: "Status",
                  placeholder: "Select",
                  mandatory: true,
                  value: Status.find(option => option.value === createJob?.jobStatus) || createJob?.jobStatus || 'active',
                  name: "jobStatus",
                  readOnly: isUpdate ? false : true,
                  reactSelect: true,
                  reactSelectOptions: Status,
                  error: errors.jobStatus,
                  className: `${isUpdate ? "block" : "hidden"}`
                })
              )}
            </div>
          </div>

          <div className='col-span-1 md:col-span-3 bg-white p-3 rounded-xl'>
            <div className="font-medium text-lg  mb-2 flex items-center gap-3">Description  <sup className="text-red-500 text-base">*</sup> </div>
            <ReactQuill
              theme="snow"
              value={createJob?.description}
              name="description"
              onChange={(value) => handleDesChange(value)}
              modules={modules}
              formats={formats}
              placeholder="Enter your JD here..."
              required={true}
              className="rounded-lg"
            />
            <div className={`${!errors.description ? "" : "bg-red-100 px-3 py-[1px] text-[12px] text-red-500 mt-1 flex items-center rounded-md font-normal"}`}>{!errors.description ? "" : errors.description}</div>
          </div>

          <div className='flex items-center gap-2'>
            <p>Post on career portal</p>
            <input
              type="checkbox"
              name="postOnCareerPortal"
              checked={createJob?.postOnCareerPortal || false}
              onChange={(e) =>
                handleChange({
                  target: {
                    name: "postOnCareerPortal",
                    value: e.target.checked,
                  },
                })
              }
            />
          </div>

        </div>
        <div className='flex justify-end mt-4 items-center text-white font-semibold'>
          <button onClick={handleSubmit} type='button' className='bg-primary-200 px-14 py-2 rounded-lg'>{loading ? "Processing..." : (isUpdate ? "Update Job" : "Submit Job")}</button>
        </div>
      </form>
    </div>
  )
}
